// kpiActions.js
export const SET_LAHLOOB_KPI_DATA = "SET_LAHLOOB_KPI_DATA";

export const setLahloobKPIData = (data) => ({
  type: SET_LAHLOOB_KPI_DATA,
  payload: data,
});